export default __webpack_public_path__ + "fd44fdf4aaa088b17325a3043a02648b.png";